<template>
  <div class="duration-picker">
    <label class="form__label duration-picker__label" for="duration">Duration</label>

    <input
      id="duration"
      class="duration-picker__input"
      name="duration"
      type="range"
      min="30"
      max="300"
      step="30"
      v-model="durationValue"
      @input="$emit('input', parseInt(durationValue), 10)"
    />
    <span class="duration-picker__output">
      <output class="form__output" name="durationDisplay" for="duration" :value="durationValue">
        {{ durationValue }}
      </output>
      <span>min</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'DurationPicker',

  props: {
    value: {
      type: Number,
      default: 30
    }
  },

  data () {
    return {
      durationValue: undefined
    }
  },

  mounted () {
    this.durationValue = this.value
  }
}
</script>

<style lang="scss">
@import "@/assets/_range";

.duration-picker {
  margin-bottom: 1rem;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  align-items: center;
}

.duration-picker__label {
  grid-column: 1 / -1;
}

.duration-picker__input {
  @include range-input;
}

.duration-picker__output {
  width: 5ch;
  display: flex;
  justify-content: flex-end;
  font-size: .8rem;
  font-weight: bold;
  text-align: right;
}
</style>
